import { Component, OnInit, Type, ViewChild, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { CollectiveComponentLoaderService } from './../../shared/service/collective-component-loader';
import { HeaderDirective } from './header.directive';
import { GlobalNamespace as _GlobalNS } from './../../../environments/environment';
import { PropertyService } from './../property.service';
import { GlobalService } from './../../core/global.service';
import { Subscription } from 'rxjs';
import {ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-property-header',
  templateUrl: './property-header.component.html',
  styleUrls: ['./property-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class PropertyHeaderComponent implements OnInit, OnDestroy {
  @ViewChild(HeaderDirective) headerHost: HeaderDirective;

  routes: object = (<any>_GlobalNS).routes.property;
  properties: object[] = [];
  api = (<any>_GlobalNS).api.property.search;
  searchParams: object = {};
  subscription: Subscription;
  loading = true;
  strategy: any;
  canAccessLibrary = this._global.find((<any>_GlobalNS).paths.canAccessLibrary);
  canAccessOffer = this._global.find((<any>_GlobalNS).paths.canAccessOffer);
  canAddMessage = this._global.find((<any>_GlobalNS).paths.canAddMessage);
  messageCount = this._global.find((<any>_GlobalNS).paths.messageCount);
  canViewMessages = this._global.find((<any>_GlobalNS).paths.canViewMessages);
  canAccessExpense = this._global.find((<any>_GlobalNS).paths.canAccessExpense);
  canViewHeaderSummary = this._global.find((<any>_GlobalNS).paths.canViewHeaderSummary);
  canViewNotes = this._global.find((<any>_GlobalNS).paths.canViewNotes);  
  propertyStrategy: string;

  constructor(
    private _headerComponentService: CollectiveComponentLoaderService,
    private _propertyService: PropertyService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private _global: GlobalService
  ) { }

  ngOnInit() {
    const viewContainerRef = this.headerHost.viewContainerRef;
    viewContainerRef.clear();

    this.subscription = this._propertyService.getDataPropertyById().subscribe((res) => {
      this.strategy = this.getListOfComponents((<any>res).data[0].DispositionStrategyGroupKey);
      this.propertyStrategy =  (<any>res).data[0].DispositionStrategyGroupKey;
      this.strategy.map((component) => {

        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);

        const componentRef = viewContainerRef.createComponent(componentFactory).instance;
        componentRef['showOpenIcon'] = true;
        componentRef['property'] = (<any>res).data[0];
        componentRef['routes'] = this.routes;
      });
      this.loading = false;
    });
  }

  getLowerCase(strategy: string): string {
    return strategy.toLowerCase();
  }

  getListOfComponents(key: string): Type<any>[] {
    const strategyKey = (key === null) ? 'other' : key;
    const checkIfExists = this._headerComponentService.getByKey(this.getLowerCase(strategyKey));
    // tslint:disable-next-line:max-line-length
    return (checkIfExists === undefined) ? this._headerComponentService.getByKey('other') : this._headerComponentService.getByKey(this.getLowerCase(strategyKey));
  }

  navigateUri(route: string) {
    const propertyId = this._global.find((<any>_GlobalNS).paths.PropertyId);
    const library = `${(<any>_GlobalNS).routes.property.library}&property_id=${propertyId}`;
    const noteSummaryAll = `${(<any>_GlobalNS).routes.property.noteSummaryAll}&property_id=${propertyId}`;
    const noteSummaryAdd = `${(<any>_GlobalNS).routes.property.noteSummaryAdd}&property_id=${propertyId}`;
    const propertyNotes = `${(<any>_GlobalNS).routes.property.propertyNotes}&property_id=${propertyId}`;
    this._global.document.location.href = (route === 'library') ? library : (route === 'noteSummaryAll') ? noteSummaryAll : (route === 'noteSummaryAdd') ? noteSummaryAdd : propertyNotes;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
